export const roleList = (state) => state.roleList;
export const getStatusRefreshData = (state) => state.refreshData;

export const getPaginatedGroupList = (state) => state.paginatedGroupsList;

export const loadingRoles = (state) => state.loadingRoles;

export const roleTableData = (state) => state.roleTableData;

export const getRoleDataByID = (state) => (id) => state.roleTableData.filter(x => x.id === id)[0];

export const getUsersOfARole = (state) => (id) => state.userList.filter(user => user.roles.filter(role => role.id === id).length > 0);

export const newRoleList = (state) => state.newRoleList;

export const getPermissionsRoleList = (state) => state.selectedPermissions;

export const getCurrentPermissions = (state) => state.currentPermissions || [];

export const getCurrentRolePermissions = (state) => state.currentRolePermissions || [];

/* add role on user */
export const rolesDDL = (state) => state.rolesDDL;

export const getRolesUserList = (state) => state.selectedRoles;

export const getCurrentRoles = (state) => state.currentRolesForUser || [];

export const getDetailsCurrentRole = (state) => state.selectedEditRoleDetails;

// get Manage Group list App
export const getGroupsListApp = (state) => state.currentGroupsListApp;
// get initial app groups on load - manage group app
export const getAppGroupsInitialData = (state) => state.appGroupsInitialData;

// Manage Group App - get Current selected group Details
export const getCurrentGroupSelected = (state) => state.currentSelectedGroup;

// get all selected members
export const getSelectedMembers = (state) => state.selectedMembers;

// get all selected members ids
export const getSelectedMembersIds = (state) => state.selectedMembersIds;

export const appSettingsData = (state) => state.appSettingsData;

// get all members data
export const getAllMembersData = (state) => state.allMembersData;

export const getCurrentMembers = (state) => state.currentMembers;

export const getParentsGroupSelected = (state) => state.parentsGroupSelected;

export const getPermissionsRolesGroupSelected = (state) => state.permissionsRolesGroupSelected;
